import { createStyles } from '../../core/withStyles';
const styles = (theme) => createStyles({
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: theme.modal.overlayBackground,
    },
});
export default styles;
//# sourceMappingURL=Overlay.styles.js.map